import * as React from 'react';
import { ParagraphText } from '@leagueplatform/genesis-core';
import type { ConfigMessage } from '@web-config-app/core';

export interface SuccessMessageProps {
  message: ConfigMessage;
  removeConfigMessage?: (id: string) => void;
  removeDelay?: number;
}

export const SuccessMessage = ({
  message,
  removeConfigMessage,
  removeDelay = 5000,
}: SuccessMessageProps) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      removeConfigMessage?.(message.id);
    }, removeDelay);

    return () => clearTimeout(timer);
  }, [message.id, removeConfigMessage, removeDelay]);

  return <ParagraphText as="li">{message.text}</ParagraphText>;
};
